const getFieldErrors = function getFieldErrors(error) {
  let errors = {};
  if (error.userDetails) {
    errors = error.userDetails;
  }
  return errors;
};

export default getFieldErrors;
